{
  "pt": {
    "button": {
      "actions": {
        "add": "Adicionar",
        "cancel": "Cancelar",
        "close": "Fechar",
        "copyEmail": "Copiar correio eletrónico",
        "create": "Criar",
        "delete": "Eliminar",
        "display": "Mostrar",
        "edit": "Editar",
        "hide": "Esconder",
        "loading": "Carregamento",
        "move": "Mover",
        "move_down": "Mover para baixo",
        "move_up": "Mover para cima",
        "no": "Não",
        "reactivateEmailAddress": "Reativar o endereço de e-mail",
        "reset": "Reiniciar",
        "save": "Guardar",
        "save_changes": "Guardar alterações",
        "save_message": "Guardar mensagem",
        "saving": "Poupança",
        "share": "Partilhar",
        "startTour": "Iniciar a viagem",
        "uploadingDocuments": "Carregamento de documentos",
        "yes": "Sim"
      }
    }
  }
}
